module.exports = __webpack_public_path__ + "img/titleimg1.b0e517ea.png";